export const GET_SINGLE_FEATURE_START = 'GET_SINGLE_FEATURE_START';
export const GET_SINGLE_FEATURE_ERROR = 'GET_SINGLE_FEATURE_ERROR';
export const GET_SINGLE_FEATURE_SUCCESS =
  'GET_SINGLE_FEATURE_SUCCESS';
